export default "__VITE_ASSET__5e3cb9d3__"